import CheckPermissions from 'components/CheckPermissions';
import routes from 'constants/routes.json';
import MeetingStatusProvider from 'providers/MeetingStatusProvider';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import HttpError from 'routes/http-error';
import Admin from 'routes/admin';
import RosterAnalysis from 'routes/analysis';
import Classroom from 'routes/classroom';
import ConferenceSettings from 'routes/conference-settings';
import Conference from 'routes/conference/index';
import CreateOrJoin from 'routes/create-or-join';
import Vod from 'routes/vod';
import Home from 'routes/home';
import Recording from 'routes/recording';
import * as utilsActions from 'store/utils/utilActions';
import PropTypes from 'prop-types';
import config from 'config';

const standardRoutes = [
  // [routes.LOGIN, Login],
  // [routes.CREATE_USER, CreateUser],
  // [routes.MOODLE, Moodle],
  [routes.ROSTER_ANALYSIS, RosterAnalysis],
  // [routes.SEARCH, Search],
  // [routes.KENDRA, Kendra],
  // [routes.DEBUG, Debug],
  [routes.CONFERENCE, Conference],
  [routes.CONFERENCE_SETTINGS, ConferenceSettings],
  [routes.ADMIN, Admin],
  [routes.RECORDING, Recording],
  [routes.VOD, Vod],
];

const { IS_PRODUCTION } = config;

export default function Routes() {
  const { classMode } = useSelector(({ user }) => ({ classMode: user.classMode }));
  const [hasCheckedPermissions, setHasCheckedPermissions] = useState(false);

  if (!IS_PRODUCTION) {
    standardRoutes.push([routes.HOME, Home, true]);
  }

  const location = useLocation();

  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(utilsActions.setPushAction({ push: history.push }));
    // eslint-disable-next-line
  }, []);

  const PrivateRoute = ({ children, path }) => {
    const shouldRedirect = !!classMode;
    return (
      <Route path={path}>
        {shouldRedirect ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: routes.LOGIN,
              state: { from: location.pathname, search: location.search },
            }}
          />
        )}
      </Route>
    );
  };
  PrivateRoute.propTypes = {
    children: PropTypes.node,
    path: PropTypes.string,
  };

  return (
    <>
      <Switch>
        <PrivateRoute path={routes.CLASSROOM}>
          <CheckPermissions
            hasCheckedPermissions={hasCheckedPermissions}
            setHasCheckedPermissions={setHasCheckedPermissions}
          />
          {hasCheckedPermissions && (
            <MeetingStatusProvider>
              <Classroom />
            </MeetingStatusProvider>
          )}
        </PrivateRoute>

        <PrivateRoute path={routes.CREATE_OR_JOIN}>
          <CreateOrJoin />
        </PrivateRoute>
        {standardRoutes.map(([path, RouteComp, exact]) => (
          <Route path={path} exact={exact} key={path}>
            <RouteComp />
          </Route>
        ))}
        <Route path="/error/:error" component={ErrorFromList} />
        <Route path="*">
          <HttpError code={404} />
        </Route>
      </Switch>
    </>
  );
}

const errors = {
  failedinit: [
    502,
    "We couldn't initialize the conference for you. Please try again or contact an admin if the problem persists.",
  ],
};

function ErrorFromList({ match }) {
  let [code, message] = errors[match.params.error || ''];

  return <HttpError code={code || 502} help={message || 'Unknown error has occured'} />;
}

ErrorFromList.propTypes = {
  match: PropTypes.object,
};
